// extracted by mini-css-extract-plugin
export default {"summaryTextfield":"ReadOnlyInputField_summaryTextfield__rWyoQ","disabled":"ReadOnlyInputField_disabled__Dwrhb"};